import React, { Suspense } from "react";
import { Spin } from "antd";
const NotificationCategoriesContainer = React.lazy(
  () => import("../../../modules/NotificationCategories/components/index")
);

const NotificationCategoriesPage = () => (
  <Suspense fallback={<Spin />}>
    <NotificationCategoriesContainer />
  </Suspense>
);

export default NotificationCategoriesPage;
